import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/gifts/")({
  component: lazyRouteComponent(() => import("./-pages/account.gifts.index")),
  head: () => ({
    meta: [
      { title: "محفظة هداياي — Lecmo" },
      { name: "description", content: "هدايا متاحة في حسابك واختيار طريقة الاستلام" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
